import React, { useContext, useState } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Box, Button, Grid } from '@mui/material'
import OnboardingMultiOptionTile from 'components/OnboardingMultiOptionTile'

export function HypotheticalInvestment({ onNext, key }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const [selectedOption, setSelectedOption] = useState(null)

  const optionArray = [
    {
      optionLabel: "Buy more - it's on sale!",
      optionValue: 'buyMore',
    },
    {
      optionLabel: 'Hold and stay the course',
      optionValue: 'holdAndStayTheCourse',
    },
    {
      optionLabel: 'Sell half',
      optionValue: 'sellHalf',
    },
    {
      optionLabel: 'Sell it all to avoid more loss',
      optionValue: 'sellEverything',
    },
  ]

  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box mt={3}>
        <OnboardingMultiOptionTile
          id="hypotheticalInvestment"
          preHeader={''}
          header="Say you have $10,000 in an investment account and the market falls 20% (loss of $2,000). How would you react?"
          subHeader="Select one of the following:"
          tileSize={{ xs: 12, sm: 6, md: 6 }}
          optionArray={optionArray}
          onChange={(value) => {
            setSelectedOption(value)
            updateIntakeStateAtKey({
              riskAssessment: {
                ...intakeState?.riskAssessment,
                hypotheticalInvestment: value,
              },
            })
          }}
        />
      </Box>

      <Box mt={3} display="flex" gap={2} justifyContent="flex-end">
        <Button variant="parcoRounded" onClick={onNext} disabled={!selectedOption}>
          Next
        </Button>
      </Box>
    </Grid>
  )
}

export default HypotheticalInvestment
